import { render, staticRenderFns } from "./PermissionsByGroup.vue?vue&type=template&id=73f8e5a7&"
import script from "./PermissionsByGroup.vue?vue&type=script&lang=js&"
export * from "./PermissionsByGroup.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsByGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports